<template>
  <span class="border-start">
    <div class="container-fluid">
      <div class="row g-0" style="width: 100vw">
        <span class="border-bottom">
          <h5>Agency Details</h5>
        </span>
        <table class="table details-table table-borderless">
          <tbody class="body">
            <tr>
              <td class="head"> Agency ID</td>
            </tr>
            <tr>
              <td class="content">{{ agencyStore.currentAgency.id }}</td>
            </tr>
            <tr>
              <td class="head"> Agency Name</td>
            </tr>
            <tr>
              <td class="content">{{ agencyStore.currentAgency.name }}</td>
            </tr>
            <tr>
              <td class="head">SFTP Username</td>
            </tr>
            <tr>
              <td class="content">{{ agencyStore.currentAgency.sftpUsername }}</td>
            </tr>
            <tr>
              <td class="head">Active/Inactive</td>
            </tr>
            <tr>
              <td class="content" v-if="agencyStore.currentAgency.active == true " >
                Active
            
            </td>
            <td class="content" v-else-if="agencyStore.currentAgency.active == false">
                  Inactive
            </td>
            </tr>
            <!-- <tr>
              <td v-if="editting == false" class="content">
                {{ agencyStore.currentAgency.active }}
              </td>
              <td v-else-if="editting == true" class="content">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="activeInactive"
                    id="active"
                    :checked="agencyStore.currentAgency.active == 'Active'"
                  />
                  <label class="form-check-label" for="active"> Active </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="activeInactive"
                    id="Inactive"
                    :checked="agencyStore.currentAgency.activeInactive == 'Inactive'"
                  />
                  <label class="form-check-label" for="Inactive">
                    Inactive
                  </label>
                </div>
              </td>
            </tr> -->
            <tr>
              <td class="head">Last Modified Date</td>
            </tr>
            <tr>
              <td class="content">{{ $filters.formatDateAndTime(agencyStore.currentAgency.lastModified) }}</td>
            </tr>
            <tr>
              <td class="head">Is Proxy?</td>
            </tr>
            <tr>
              <td class="content">{{ agencyStore.currentAgency.isProxy }}</td>
            </tr>
            <tr>
              <td class="head">Has Proxy?</td>
            </tr>
            <tr>
              <td class="content">{{ agencyStore.currentAgency.hasProxy }}</td>
            </tr>
            <tr v-if="agencyStore.currentAgency.hasProxy == true || (agencyStore.currentAgency.hasProxy == false && agencyStore.currentAgency.isProxy == false)">
              <td class="head">Proxy Agency Name</td>
            </tr>
            <tr v-if="agencyStore.currentAgency.hasProxy == true">
              <td class="content">
                {{ agencyStore.currentAgency.proxyName }}
              </td>
            </tr>
            <tr v-else-if="agencyStore.currentAgency.hasProxy == false && agencyStore.currentAgency.isProxy == false">
              <td class="content">
                -
              </td>
            </tr>
            <tr v-if="agencyStore.currentAgency.hasProxy == true || (agencyStore.currentAgency.hasProxy == false && agencyStore.currentAgency.isProxy == false)">
              <td class="head">Proxy Agency ID</td>
            </tr>
            <tr v-if="agencyStore.currentAgency.hasProxy == true">
              <td class="content">
                {{ agencyStore.currentAgency.proxyId }}
              </td>
            </tr>
            <tr v-else-if="agencyStore.currentAgency.hasProxy == false && agencyStore.currentAgency.isProxy == false">
              <td class="content">
                -
              </td>
            </tr>
            <tr v-if="agencyStore.currentAgency.isProxy == true">
              <table class="table">
                <tbody class="body">
                  <tr>
                    <td class="originator-header">
                      Originator Agency Name
                    </td>
                    <td class="originator-header">
                      Originator Agency ID
                    </td>
                    <td>
                      <td class="originator-header">
                      Originator Agency Active/Inactive
                    </td>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in agencyStore.currentAgency.childAgency">
                    <td class="originator-content align-middle">
                      {{ item.childAgencyname }}
                    </td>
                    <td class="originator-content align-middle">
                      {{ item.childAgencyId }}
                    </td>
                    <td class="originator-content align-middle" v-if="item.childStatus==true">
                      active
                    </td>
                    <td class="originator-content align-middle" v-else-if="item.childStatus==false">
                      Inactive
                    </td>

                    <!-- <td>
                      <button class="btn btn-danger">Delete</button>
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <!-- <td>
                <tr v-if="editting == true">
                  <button
                    class="btn btn-outline-secondary"
                    style="margin-right: 10px"
                    data-bs-toggle="modal"
                    data-bs-target="#addNewUploadOnBehalfModal"
                    @click="changeBackgroundPosition"
                  >
                    Add Child Agency
                  </button>
                </tr>
                <span v-for="(item, index) in data" :key="index">
                  <span
                    type="button"
                    class="btn btn-secondary btn-selected position-relative"
                    style="margin-right: 10px; margin-top: 12px"
                  >
                    {{ item.agencyId }} || {{ item.agencyName }}
                    <button
                      v-if="editting == true"
                      class="btn btn-danger position-absolute top-0 start-100 translate-middle badge rounded-circle"
                      @click="removeItem(index)"
                      style="padding: 2px; width: 20px; height: 20px"
                    >
                      <i
                        class="bi-x"
                        style="font-size: 12px; padding: 0; margin: 0px"
                      ></i>
                    </button>
                  </span>
                </span>
              </td> -->
            </tr>
            <!-- <tr v-if="agencyStore.currentAgency.isProxy == true">
              <td class="content">
                <button 
                  class="btn btn-outline-secondary" 
                  data-bs-toggle="modal"
                  data-bs-target="#addNewUploadOnBehalfModal"
                  @click="changeBackgroundPosition"
                >
                  Add Originator Agency
                </button>
              </td>
            </tr> -->
          </tbody>
        </table>
        <span class="">
          <button
            class="btn btn-edit btn-outline-secondary"
            @click="changeBackgroundPosition"
            data-bs-toggle="modal"
            data-bs-target="#editAgencyModal"
          >
            Edit Agency Details
          </button>
          <!-- <button
            class="btn btn-save btn-success"
            @click="saveDetails"
            :disabled="!editting"
          >
            Save
          </button> -->
        </span>
      </div>
    </div>
    <EditAgencyModal/>
  </span>
</template>

<script setup lang="ts">
import GlobalData from "@/GlobalData";
import { ref, onMounted, watch } from "vue";
import { useAgencyStore } from "@/stores/agency";
import EditAgencyModal from "@/components/Modal/EditAgencyModal.vue"


const agencyStore = useAgencyStore();
const currentAgency = ref()

onMounted(() => {
  let editAgencyModal: any = document.getElementById(
    "editAgencyModal"
  );

  editAgencyModal.addEventListener("hidden.bs.modal", function () {
    GlobalData.getInstance().changeBackgroundPosition(
      "background-layout",
      "agency-list-item"
    );
  });
});

watch(
  () => agencyStore.currentAgency,
  (update) => {
    currentAgency.value = update;
  }
)

const changeBackgroundPosition = () => {
  GlobalData.getInstance().changeBackgroundPosition(
    "agency-list-item",
    "background-layout"
  );
};
</script>

<style lang="scss" scoped>
.container-fluid {
  float: left;
  display: flex;
  padding: 16px;
  max-width: 33.3vw;
  margin-bottom: 50px;
  overflow: auto;
}
.btn-edit {
  margin-top: 16px;
  margin-right: 2%;
  width: 48%;
}
.btn-save {
  margin-top: 16px;
  margin-right: 2%;
  width: 48%;
}
.details-table {
  margin-top: 16px;
}
td.originator-header {
  font-weight: bold;
  padding-left: 0;
}
td.originator-content {
  padding-left: 0;
}
</style>
